import { render, staticRenderFns } from "./ModrEditAbout.vue?vue&type=template&id=017e29b7&scoped=true&"
import script from "./ModrEditAbout.vue?vue&type=script&lang=js&"
export * from "./ModrEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017e29b7",
  null
  
)

export default component.exports